module.exports = __webpack_public_path__ + "img/svg/position-3.0dd4e0a7586cf7d9c659b5cf598d1843.svg";